/* 釘住的穿刺段：底部進度線 ＋ 捲動提示。

   為什麼要有：這一段會把畫面「釘住」好幾個螢幕的高度，
   捲動時畫面不往下跑，很多人會以為當掉了（Mars 的朋友實測就是這個反應）。
   進度線告訴你「捲動有在作用、還剩多少」，提示告訴你「可以繼續往下」。
   動畫演完就把提示淡出，不再干擾。 */
if (!window.__tsPinInit) {
  window.__tsPinInit = 1;
  (function () {
    function start() {
      var pin = document.querySelector(".ts-air .pin");
      if (!pin) return;
      var stage = pin.querySelector(".pin__stage") || pin;

      var prog = document.createElement("div");
      prog.className = "pin__prog";
      var hint = document.createElement("div");
      hint.className = "pin__hint";
      hint.innerHTML = '<span>繼續捲動</span>' +
        '<svg viewBox="0 0 13 8" fill="none" aria-hidden="true">' +
        '<path d="M1 1L6.5 6.5L12 1" stroke="currentColor" stroke-width="1.6" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';
      stage.appendChild(prog);
      stage.appendChild(hint);

      var ticking = false;
      function update() {
        ticking = false;
        var r = pin.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var span = pin.offsetHeight - innerHeight;
        var p = span > 0 ? (0 - r.top) / span : 0;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        prog.style.width = (p * 100).toFixed(2) + "%";
        // 動畫大約在 0.86 收尾，之後就不用再催人往下了
        hint.classList.toggle("is-done", p > 0.86 || p <= 0.01);
      }
      addEventListener("scroll", function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      addEventListener("resize", update);
      update();
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else { start(); }
  })();
}
